/* @flow */

import classNames from 'classnames';
import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import BaseIcon from 'src/shared/ui/component/icon/BaseIcon';
import styles from './LiveIcon.style';

import svg from './live.svg';

type Props = {
  className?: string,
  title?: string,
  // Self passed
};

const useStyles = createUseThemeStyles(styles);

const LiveIcon = ({ className, title }: Props): React.Node => {
  const classes = useStyles();

  return (
    <BaseIcon
      className={classNames(classes.root, className)}
      svg={svg}
      title={title}
    />
  );
};

export default React.memo<Props>(LiveIcon);
